import { IconButton as ChakraIconButton, useRecipe } from '@chakra-ui/react'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

import { buttonRecipe } from 'theme/recipes/button.recipe'

import type { ButtonSize, ButtonVariant } from 'components/ui/Button'
import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface IconButtonProperties extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'size'> {
  children: ReactNode
  isLoading?: boolean
  label: string
  size?: ButtonSize
  variant?: ButtonVariant
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProperties>(
  ({ children, className, isLoading = false, label, size = 'md', variant = 'ghost', ...properties }, reference) => {
    /* --- Section 1: Hooks --- */
    const recipe = useRecipe({ recipe: buttonRecipe })

    /* --- Section 3: Derived Values --- */
    const styles = recipe({ variant, size, iconOnly: true })

    /* --- Section 6: Render --- */
    return (
      <ChakraIconButton
        {...properties}
        aria-label={label}
        className={clsx(className)}
        css={styles}
        data-icon-only="true"
        data-size={size}
        data-variant={variant}
        loading={isLoading}
        ref={reference}
      >
        {children}
      </ChakraIconButton>
    )
  }
)

IconButton.displayName = 'IconButton'
